(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cr-aerosuit-article"]) return;
  try {
    
// Base article behaviour (reading progress, copy link). Duplicated from
// cr-article.liquid for the same reason as the CSS above.
(function () {
  function init() {
    var body = document.querySelector('[data-cr-body]');

    // Reading progress
    var bar = document.querySelector('[data-cr-progress] span');
    if (bar && body && bar.dataset.crReady !== '1') {
      bar.dataset.crReady = '1';
      var ticking = false;
      var update = function () {
        var rect = body.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        var pct = total <= 0 ? 0 : Math.min(1, Math.max(0, -rect.top / total));
        bar.style.width = (pct * 100).toFixed(2) + '%';
        ticking = false;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }

    // Copy link
    var copy = document.querySelector('[data-cr-copy]');
    if (copy && copy.dataset.crReady !== '1') {
      copy.dataset.crReady = '1';
      copy.addEventListener('click', function () {
        var url = copy.dataset.crUrl || window.location.href;
        var done = function () {
          var original = copy.textContent;
          copy.textContent = 'Link copied';
          setTimeout(function () { copy.textContent = original; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {});
        } else {
          var t = document.createElement('textarea');
          t.value = url;
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    }


    // Native share sheet. Only revealed where the browser supports it,
    // which in practice means phones. This is the only route to Instagram:
    // Instagram publishes no web share URL, but it appears in the OS sheet.
    var nativeShare = document.querySelector('[data-cr-share]');
    if (nativeShare && nativeShare.dataset.crReady !== '1' && navigator.share) {
      nativeShare.dataset.crReady = '1';
      nativeShare.hidden = false;
      nativeShare.addEventListener('click', function () {
        navigator.share({
          title: nativeShare.dataset.crTitle || document.title,
          url: nativeShare.dataset.crUrl || window.location.href
        }).catch(function () {});
      });
    }

    // FAQ accordion: opening one question closes the others.
    // The name attribute does this natively in current browsers; this
    // keeps the behaviour consistent on older ones.
    var faqItems = Array.prototype.slice.call(document.querySelectorAll('.cr-article__faq-item'));
    faqItems.forEach(function (item) {
      if (item.dataset.crReady === '1') return;
      item.dataset.crReady = '1';
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        faqItems.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ---------- Instagram embed ----------
(function () {
  // Load the Instagram embed script only when the embed comes into view,
  // so a third party script does not slow the initial page load.
  function initEmbed() {
    var holder = document.querySelector('[data-cr-ig]');
    if (!holder || holder.dataset.crReady === '1') return;
    holder.dataset.crReady = '1';

    var load = function () {
      if (window.instgrm) { window.instgrm.Embeds.process(); return; }
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.instagram.com/embed.js';
      document.body.appendChild(s);
    };

    if (!('IntersectionObserver' in window)) { load(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { load(); io.disconnect(); }
      });
    }, { rootMargin: '400px' });
    io.observe(holder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEmbed);
  } else {
    initEmbed();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-article"]) return;
  try {
    
(function () {
  function slug(text, used) {
    var base = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
    var out = base, i = 2;
    while (used[out]) { out = base + '-' + i; i++; }
    used[out] = true;
    return out;
  }

  function init() {
    var body = document.querySelector('[data-cr-body]');

    // Contents, built from the H2s in the article body
    if (body && body.dataset.crTocReady !== '1') {
      body.dataset.crTocReady = '1';
      var toc = document.querySelector('[data-cr-toc]');
      var list = document.querySelector('[data-cr-toc-list]');
      var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
      if (toc && list && headings.length >= 3) {
        var used = {};
        headings.forEach(function (h) {
          if (!h.id) h.id = slug(h.textContent || '', used);
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = (h.textContent || '').trim();
          li.appendChild(a);
          list.appendChild(li);
        });
        toc.hidden = false;
      }
    }

    // Reading progress
    var bar = document.querySelector('[data-cr-progress] span');
    if (bar && body && bar.dataset.crReady !== '1') {
      bar.dataset.crReady = '1';
      var ticking = false;
      var update = function () {
        var rect = body.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        var pct = total <= 0 ? 0 : Math.min(1, Math.max(0, -rect.top / total));
        bar.style.width = (pct * 100).toFixed(2) + '%';
        ticking = false;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }

    // Copy link
    var copy = document.querySelector('[data-cr-copy]');
    if (copy && copy.dataset.crReady !== '1') {
      copy.dataset.crReady = '1';
      copy.addEventListener('click', function () {
        var url = copy.dataset.crUrl || window.location.href;
        var done = function () {
          var original = copy.textContent;
          copy.textContent = 'Link copied';
          setTimeout(function () { copy.textContent = original; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {});
        } else {
          var t = document.createElement('textarea');
          t.value = url;
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    }


    // Native share sheet. Only revealed where the browser supports it,
    // which in practice means phones. This is the only route to Instagram:
    // Instagram publishes no web share URL, but it appears in the OS sheet.
    var nativeShare = document.querySelector('[data-cr-share]');
    if (nativeShare && nativeShare.dataset.crReady !== '1' && navigator.share) {
      nativeShare.dataset.crReady = '1';
      nativeShare.hidden = false;
      nativeShare.addEventListener('click', function () {
        navigator.share({
          title: nativeShare.dataset.crTitle || document.title,
          url: nativeShare.dataset.crUrl || window.location.href
        }).catch(function () {});
      });
    }

    // FAQ accordion: opening one question closes the others.
    // The name attribute does this natively in current browsers; this
    // keeps the behaviour consistent on older ones.
    var faqItems = Array.prototype.slice.call(document.querySelectorAll('.cr-article__faq-item'));
    faqItems.forEach(function (item) {
      if (item.dataset.crReady === '1') return;
      item.dataset.crReady = '1';
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        faqItems.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-blog"]) return;
  try {
    
(function () {
  function init() {
    var grid = document.querySelector('[data-cr-grid]');
    if (!grid || grid.dataset.crReady === '1') return;
    grid.dataset.crReady = '1';

    var chips = Array.prototype.slice.call(document.querySelectorAll('[data-cr-filter]'));
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.cr-blog__card'));
    var none = document.querySelector('[data-cr-none]');
    var count = document.querySelector('[data-cr-count]');
    var reset = document.querySelector('[data-cr-reset]');

    function apply(filter) {
      var shown = 0;
      cards.forEach(function (card) {
        var cats = (card.dataset.crCats || '').split(' ');
        var match = filter === 'all' || cats.indexOf(filter) > -1;
        card.hidden = !match;
        if (match) shown++;
      });
      chips.forEach(function (chip) {
        var on = chip.dataset.crFilter === filter;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (none) none.hidden = shown !== 0;
      if (count) {
        count.textContent = shown === 0 ? '' : shown + (shown === 1 ? ' article' : ' articles');
      }
      if (filter === 'all') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      } else {
        history.replaceState(null, '', '#' + filter);
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { apply(chip.dataset.crFilter); });
    });
    if (reset) reset.addEventListener('click', function () { apply('all'); });

    var start = (window.location.hash || '').replace('#', '');
    var valid = chips.some(function (c) { return c.dataset.crFilter === start; });
    apply(valid ? start : 'all');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-footer"] && !Shopify.designMode) return;
  try {
    
  /* ---- Footer link column accordions (mobile) ---- */
  (function () {
    var mq = window.matchMedia('(max-width: 640px)');
    var labels = document.querySelectorAll('.cr-footer__col-links > .cr-footer__col-label');
    if (!labels.length) return;

    function toggleLabel(e) {
      if (!mq.matches) return;
      e.preventDefault();
      var btn = e.currentTarget;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      if (!isOpen) {
        labels.forEach(function (other) {
          if (other !== btn) other.setAttribute('aria-expanded', 'false');
        });
      }
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }

    function resetIfDesktop() {
      if (!mq.matches) {
        labels.forEach(function (l) { l.setAttribute('aria-expanded', 'false'); });
      }
    }

    labels.forEach(function (l) { l.addEventListener('click', toggleLabel); });
    if (mq.addEventListener) {
      mq.addEventListener('change', resetIfDesktop);
    } else if (mq.addListener) {
      mq.addListener(resetIfDesktop);
    }
  })();

  /* ---- Footer signup -> Spoks ---- */
  (function () {
    /* CHANGE THIS ONE LINE to move behind a Cloudflare Worker later. */
    var CR_SPOKS_ENDPOINT = 'https://webhook.spoks.com/12dd42b3-d9d4-4460-8c29-3ece158e8da8';

    var form = document.querySelector('.cr-footer__signup-form');
    if (!form) return;

    var name = form.querySelector('#cr-signup-name');
    var email = form.querySelector('#cr-signup-email');
    var whoBoxes = form.querySelectorAll('.cr-signup-who');
    var audience = form.querySelector('.cr-footer__signup-audience');
    var phone = form.querySelector('#cr-signup-phone');
    var okEmail = form.querySelector('#cr-signup-consent-email');
    var okSms = form.querySelector('#cr-signup-consent-sms');
    var honeypot = form.querySelector('#cr-signup-company');
    var button = form.querySelector('.cr-footer__signup-btn');
    var status = form.querySelector('.cr-footer__signup-status');
    var done = false;

    function say(message, kind) {
      status.textContent = message;
      status.className = 'cr-footer__signup-status is-' + kind;
    }

    function flag(field, bad) {
      if (!field) return;
      if (bad) { field.classList.add('is-invalid'); } else { field.classList.remove('is-invalid'); }
    }

    /* UK-friendly: 07700 900001 -> +447700900001. Leaves other formats alone. */
    function tidyPhone(raw) {
      var p = (raw || '').replace(/[^\d+]/g, '');
      if (!p) return '';
      if (p.charAt(0) === '+') return p;
      if (p.indexOf('00') === 0) return '+' + p.slice(2);
      if (p.charAt(0) === '0') return '+44' + p.slice(1);
      if (p.indexOf('44') === 0) return '+' + p;
      return p;
    }

    /* Tell the Shopify custom pixel a signup happened. The pixel then fires
       Meta and GA4 — see cr-signup-pixel.js. Publishing is the only route,
       because custom pixels run sandboxed and cannot see this page's DOM. */
    function trackSignup(smsOptIn) {
      var payload = { source: 'footer', sms_consent: !!smsOptIn };
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('cr_signup', payload);
          return;
        }
      } catch (e) {}
      /* Fallbacks, only used if the tags happen to sit directly on the page */
      try { if (typeof window.gtag === 'function') window.gtag('event', 'cr_signup', payload); } catch (e) {}
      try { if (typeof window.fbq === 'function') window.fbq('track', 'CompleteRegistration', { content_name: 'newsletter signup', content_category: 'footer' }); } catch (e) {}
    }

    /* Clear the audience error as soon as they tick something */
    for (var b = 0; b < whoBoxes.length; b++) {
      whoBoxes[b].addEventListener('change', function () {
        if (audience) audience.classList.remove('has-error');
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (done) return;

      /* Bot filled the hidden field. Look successful, send nothing. */
      if (honeypot && honeypot.value) {
        say('You are on the list. Watch your inbox.', 'ok');
        form.reset();
        return;
      }

      flag(name, false);
      flag(email, false);
      flag(phone, false);
      if (audience) audience.classList.remove('has-error');

      /* FIRST NAME. Two characters is a floor, not a real check — "Jo" and
         "Al" are names, and there is no honest way to test whether a string
         is someone's name. */
      var typed = (name.value || '').trim();
      if (typed.length < 2) {
        flag(name, true);
        say('Please add your first name.', 'error');
        name.focus();
        return;
      }
      /* FIRST WORD ONLY — Spoks has one Name field, and whatever sits in it
         is what a greeting prints. People type their full name into anything
         labelled "name", so this enforces it rather than hoping. Deliberately
         not a general name parser: splitting human names properly is not
         possible, and the first word is right for a greeting. */
      var who = typed.split(/\s+/)[0];

      var address = (email.value || '').trim();

      if (!/^[^@\s]+@[^@\s.]+\.[^@\s]+$/.test(address)) {
        flag(email, true);
        say('That email address does not look right. Check it and try again.', 'error');
        email.focus();
        return;
      }

      var picked = [];
      for (var w = 0; w < whoBoxes.length; w++) {
        if (whoBoxes[w].checked) picked.push(whoBoxes[w].value);
      }
      if (!picked.length) {
        if (audience) audience.classList.add('has-error');
        say('Tick at least one box so we know what to send you.', 'error');
        if (whoBoxes.length) whoBoxes[0].focus();
        return;
      }

      if (!okEmail.checked) {
        say('Tick the first box to confirm we can email you.', 'error');
        okEmail.focus();
        return;
      }

      var number = tidyPhone(phone.value);
      if ((phone.value || '').trim() && number.replace(/\D/g, '').length < 10) {
        flag(phone, true);
        say('That mobile number is too short. Correct it, or leave it blank.', 'error');
        phone.focus();
        return;
      }

      if (okSms.checked && !number) {
        flag(phone, true);
        say('Add a mobile number to get text updates.', 'error');
        phone.focus();
        return;
      }

      var tags = ['footer-signup'];
      if (okSms.checked && number) tags.push('sms-consent');
      for (var t = 0; t < picked.length; t++) tags.push('who-' + picked[t]);

      /* `name` is the Spoks webhook key — proven by a live signup. Do NOT
         also send first_name; one key so a future test stays conclusive. */
      var payload = { email: address, name: who, tags: tags };
      if (number) payload.phone = number;

      button.disabled = true;
      say('Signing you up…', 'busy');

      fetch(CR_SPOKS_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          done = true;
          trackSignup(okSms.checked && number);
          form.reset();
          button.disabled = false;
          say('You are on the list. Watch your inbox.', 'ok');
        })
        .catch(function () {
          button.disabled = false;
          say('That did not send. Email info@customracewear.co.uk and we will add you.', 'error');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-join"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Same endpoint as the footer form and the popup. */
    var CR_SPOKS_ENDPOINT = 'https://webhook.spoks.com/12dd42b3-d9d4-4460-8c29-3ece158e8da8';

    var form = document.querySelector('.cr-join__form');
    if (!form) return;

    var name = form.querySelector('#cr-join-name');
    var email = form.querySelector('#cr-join-email');
    var phone = form.querySelector('#cr-join-phone');
    var okEmail = form.querySelector('#cr-join-consent-email');
    var okSms = form.querySelector('#cr-join-consent-sms');
    var honeypot = form.querySelector('#cr-join-company');
    var button = form.querySelector('.cr-join__btn');
    var status = form.querySelector('.cr-join__status');
    var whoBoxes = form.querySelectorAll('.cr-join-who');
    var audience = form.querySelector('.cr-join__audience');
    var done = false;

    function say(message, kind) {
      status.textContent = message;
      status.className = 'cr-join__status is-' + kind;
    }

    function flag(field, bad) {
      if (!field) return;
      if (bad) { field.classList.add('is-invalid'); } else { field.classList.remove('is-invalid'); }
    }

    /* UK-friendly: 07700 900001 -> +447700900001. Leaves other formats alone. */
    function tidyPhone(raw) {
      var p = (raw || '').replace(/[^\d+]/g, '');
      if (!p) return '';
      if (p.charAt(0) === '+') return p;
      if (p.indexOf('00') === 0) return '+' + p.slice(2);
      if (p.charAt(0) === '0') return '+44' + p.slice(1);
      if (p.indexOf('44') === 0) return '+' + p;
      return p;
    }

    /* Tell the Shopify custom pixel a signup happened, source 'join'. The
       pixel fires Meta CompleteRegistration and the GA4 cr_signup event —
       see the Meta Pixel under Settings > Customer events. Publishing is the
       only route, because custom pixels run sandboxed and cannot see the
       theme's DOM. */
    function trackSignup(smsOptIn) {
      var payload = { source: 'join', sms_consent: !!smsOptIn };
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('cr_signup', payload);
          return;
        }
      } catch (e) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', 'cr_signup', payload); } catch (e) {}
      try { if (typeof window.fbq === 'function') window.fbq('track', 'CompleteRegistration', { content_name: 'newsletter signup', content_category: 'join' }); } catch (e) {}
    }

    for (var b = 0; b < whoBoxes.length; b++) {
      whoBoxes[b].addEventListener('change', function () {
        if (audience) audience.classList.remove('has-error');
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (done) return;

      /* Bot filled the hidden field. Look successful, send nothing. */
      if (honeypot && honeypot.value) {
        say('You are on the list. Watch your inbox.', 'ok');
        form.reset();
        return;
      }

      flag(name, false);
      flag(email, false);
      flag(phone, false);
      if (audience) audience.classList.remove('has-error');

      /* Two characters is a floor, not a real check — "Jo" and "Al" are
         names, and there is no honest way to test whether a string is
         someone's name. */
      var typed = (name.value || '').trim();
      if (typed.length < 2) {
        flag(name, true);
        say('Please add your first name.', 'error');
        name.focus();
        return;
      }
      /* FIRST WORD ONLY — see the note at the top of this file. */
      var who = typed.split(/\s+/)[0];

      var address = (email.value || '').trim();

      if (!/^[^@\s]+@[^@\s.]+\.[^@\s]+$/.test(address)) {
        flag(email, true);
        say('That email address does not look right. Check it and try again.', 'error');
        email.focus();
        return;
      }

      var picked = [];
      for (var w = 0; w < whoBoxes.length; w++) {
        if (whoBoxes[w].checked) picked.push(whoBoxes[w].value);
      }
      if (!picked.length) {
        if (audience) audience.classList.add('has-error');
        say('Tick at least one box so we know what to send you.', 'error');
        if (whoBoxes.length) whoBoxes[0].focus();
        return;
      }

      if (!okEmail.checked) {
        say('Tick the first box to confirm we can email you.', 'error');
        okEmail.focus();
        return;
      }

      var number = tidyPhone(phone.value);
      if ((phone.value || '').trim() && number.replace(/\D/g, '').length < 10) {
        flag(phone, true);
        say('That mobile number is too short. Correct it, or leave it blank.', 'error');
        phone.focus();
        return;
      }

      if (okSms.checked && !number) {
        flag(phone, true);
        say('Add a mobile number to get text updates.', 'error');
        phone.focus();
        return;
      }

      var tags = ['join-page'];
      if (okSms.checked && number) tags.push('sms-consent');
      for (var t = 0; t < picked.length; t++) tags.push('who-' + picked[t]);

      /* `name` is the Spoks webhook key — proven by a live signup. Do NOT
         also send first_name; one key so a future test stays conclusive. */
      var payload = { email: address, name: who, tags: tags };
      if (number) payload.phone = number;

      button.disabled = true;
      say('Signing you up…', 'busy');

      fetch(CR_SPOKS_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          done = true;
          trackSignup(okSms.checked && number);
          form.reset();
          button.disabled = false;
          say('You are on the list. Watch your inbox.', 'ok');
        })
        .catch(function () {
          button.disabled = false;
          say('That did not send. Email info@customracewear.co.uk and we will add you.', 'error');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-signup-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---- The three things worth changing ---- */
    var CR_SPOKS_ENDPOINT = 'https://webhook.spoks.com/12dd42b3-d9d4-4460-8c29-3ece158e8da8';
    var CR_POPUP_SCROLL_PCT = 40;   /* appears once 40% of the page is scrolled */
    var CR_POPUP_DELAY_MS = 15000;  /* fallback, if they never scroll */
    var CR_POPUP_SNOOZE_DAYS = 30;  /* how long a dismissal lasts */

    var SIGNED_KEY = 'cr_popup_signed';
    var SNOOZE_KEY = 'cr_popup_snoozed_until';

    var popup = document.getElementById('cr-popup');
    if (!popup) return;

    var panel = popup.querySelector('.cr-popup__panel');
    var form = popup.querySelector('.cr-popup__form');
    var name = popup.querySelector('#cr-popup-name');
    var email = popup.querySelector('#cr-popup-email');
    var whoBoxes = popup.querySelectorAll('.cr-popup-who');
    var audience = popup.querySelector('.cr-popup__audience');
    var phone = popup.querySelector('#cr-popup-phone');
    var okEmail = popup.querySelector('#cr-popup-consent-email');
    var okSms = popup.querySelector('#cr-popup-consent-sms');
    var honeypot = popup.querySelector('#cr-popup-company');
    var button = popup.querySelector('.cr-popup__btn');
    var status = popup.querySelector('.cr-popup__status');
    var lastFocus = null;
    var opened = false;
    var done = false;

    /* Below this width the popup is a non-blocking bottom bar, not a modal. */
    var mqMobile = window.matchMedia('(max-width: 640px)');
    function isModal() { return !mqMobile.matches; }

    /* localStorage can throw in private mode — never let that break the page */
    function store(key, value) {
      try { window.localStorage.setItem(key, value); } catch (e) {}
    }
    function read(key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    }

    function shouldShow() {
      if (read(SIGNED_KEY) === 'true') return false;
      var until = parseInt(read(SNOOZE_KEY) || '0', 10);
      if (until && Date.now() < until) return false;
      return true;
    }

    function snooze() {
      store(SNOOZE_KEY, String(Date.now() + CR_POPUP_SNOOZE_DAYS * 86400000));
    }

    function open() {
      if (opened) return;
      opened = true;
      lastFocus = document.activeElement;
      panel.setAttribute('aria-modal', isModal() ? 'true' : 'false');
      popup.hidden = false;
      /* next frame so the transition runs */
      window.requestAnimationFrame(function () {
        popup.classList.add('is-open');
        /* Don't steal focus on mobile — it scrolls the page and zooms the field. */
        if (isModal() && name) name.focus();
      });
      document.addEventListener('keydown', onKeydown);
    }

    function close(remember) {
      if (remember !== false) snooze();
      popup.classList.remove('is-open');
      document.removeEventListener('keydown', onKeydown);
      window.setTimeout(function () {
        popup.hidden = true;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, 250);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        close();
        return;
      }
      /* keep tabbing inside the dialog — desktop only, where it is modal */
      if (e.key !== 'Tab' || !isModal()) return;
      var focusable = panel.querySelectorAll('button, [href], input, select, textarea');
      var list = [];
      for (var i = 0; i < focusable.length; i++) {
        if (!focusable[i].disabled && focusable[i].offsetParent !== null) list.push(focusable[i]);
      }
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    var closers = popup.querySelectorAll('[data-cr-popup-close]');
    for (var c = 0; c < closers.length; c++) {
      closers[c].addEventListener('click', function () { close(); });
    }

    function say(message, kind) {
      status.textContent = message;
      status.className = 'cr-popup__status is-' + kind;
    }

    function flag(field, bad) {
      if (!field) return;
      if (bad) { field.classList.add('is-invalid'); } else { field.classList.remove('is-invalid'); }
    }

    /* UK-friendly: 07700 900001 -> +447700900001. Leaves other formats alone. */
    function tidyPhone(raw) {
      var p = (raw || '').replace(/[^\d+]/g, '');
      if (!p) return '';
      if (p.charAt(0) === '+') return p;
      if (p.indexOf('00') === 0) return '+' + p.slice(2);
      if (p.charAt(0) === '0') return '+44' + p.slice(1);
      if (p.indexOf('44') === 0) return '+' + p;
      return p;
    }

    /* Tell the Shopify custom pixel a signup happened. The pixel then fires
       Meta and GA4 — see cr-signup-pixel.js. Publishing is the only route,
       because custom pixels run sandboxed and cannot see this page's DOM. */
    function trackSignup(smsOptIn) {
      var payload = { source: 'popup', sms_consent: !!smsOptIn };
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('cr_signup', payload);
          return;
        }
      } catch (e) {}
      /* Fallbacks, only used if the tags happen to sit directly on the page */
      try { if (typeof window.gtag === 'function') window.gtag('event', 'cr_signup', payload); } catch (e) {}
      try { if (typeof window.fbq === 'function') window.fbq('track', 'CompleteRegistration', { content_name: 'newsletter signup', content_category: 'popup' }); } catch (e) {}
    }

    /* Clear the audience error as soon as they tick something */
    for (var b = 0; b < whoBoxes.length; b++) {
      whoBoxes[b].addEventListener('change', function () {
        if (audience) audience.classList.remove('has-error');
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (done) return;

      if (honeypot && honeypot.value) {
        say('You are on the list. Watch your inbox.', 'ok');
        form.reset();
        return;
      }

      flag(name, false);
      flag(email, false);
      flag(phone, false);
      if (audience) audience.classList.remove('has-error');

      /* FIRST NAME. Two characters is a floor, not a real check — "Jo" and
         "Al" are names, and there is no honest way to test whether a string
         is someone's name. */
      var typed = (name.value || '').trim();
      if (typed.length < 2) {
        flag(name, true);
        say('Please add your first name.', 'error');
        name.focus();
        return;
      }
      /* FIRST WORD ONLY — see the note at the top of this file. */
      var who = typed.split(/\s+/)[0];

      var address = (email.value || '').trim();

      if (!/^[^@\s]+@[^@\s.]+\.[^@\s]+$/.test(address)) {
        flag(email, true);
        say('That email address does not look right. Check it and try again.', 'error');
        email.focus();
        return;
      }

      var picked = [];
      for (var w = 0; w < whoBoxes.length; w++) {
        if (whoBoxes[w].checked) picked.push(whoBoxes[w].value);
      }
      if (!picked.length) {
        if (audience) audience.classList.add('has-error');
        say('Tick at least one box so we know what to send you.', 'error');
        if (whoBoxes.length) whoBoxes[0].focus();
        return;
      }

      if (!okEmail.checked) {
        say('Tick the first box to confirm we can email you.', 'error');
        okEmail.focus();
        return;
      }

      var number = tidyPhone(phone.value);
      if ((phone.value || '').trim() && number.replace(/\D/g, '').length < 10) {
        flag(phone, true);
        say('That mobile number is too short. Correct it, or leave it blank.', 'error');
        phone.focus();
        return;
      }

      if (okSms.checked && !number) {
        flag(phone, true);
        say('Add a mobile number to get text updates.', 'error');
        phone.focus();
        return;
      }

      var tags = ['popup-signup'];
      if (okSms.checked && number) tags.push('sms-consent');
      for (var t = 0; t < picked.length; t++) tags.push('who-' + picked[t]);

      /* `name` is the Spoks webhook key — proven by a live signup. Do NOT
         also send first_name; one key so a future test stays conclusive. */
      var payload = { email: address, name: who, tags: tags };
      if (number) payload.phone = number;

      button.disabled = true;
      say('Signing you up…', 'busy');

      fetch(CR_SPOKS_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          done = true;
          trackSignup(okSms.checked && number);
          store(SIGNED_KEY, 'true');
          form.reset();
          button.disabled = false;
          say('You are on the list. Watch your inbox.', 'ok');
          window.setTimeout(function () { close(false); }, 2200);
        })
        .catch(function () {
          button.disabled = false;
          say('That did not send. Email info@customracewear.co.uk and we will add you.', 'error');
        });
    });

    if (shouldShow()) {
      var timer = null;

      function scrolledPercent() {
        var doc = document.documentElement;
        var scrollable = doc.scrollHeight - window.innerHeight;
        if (scrollable <= 0) return 0;
        return ((window.pageYOffset || doc.scrollTop || 0) / scrollable) * 100;
      }

      function disarm() {
        if (timer) window.clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
      }

      function onScroll() {
        if (scrolledPercent() >= CR_POPUP_SCROLL_PCT) {
          disarm();
          open();
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      timer = window.setTimeout(function () {
        disarm();
        open();
      }, CR_POPUP_DELAY_MS);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  /* Mobile accordion: collapse link columns on small viewports.
     Desktop keeps them all open (<details open> on render). */
  (function () {
    var mq = window.matchMedia('(max-width: 600px)');
    var cols = document.querySelectorAll('.cr-footer__col--links');
    if (!cols.length) return;

    function sync(matches) {
      cols.forEach(function (c) {
        if (matches) {
          c.removeAttribute('open');
        } else {
          c.setAttribute('open', '');
        }
      });
    }
    sync(mq.matches);
    if (mq.addEventListener) {
      mq.addEventListener('change', function (e) { sync(e.matches); });
    } else if (mq.addListener) {
      mq.addListener(function (e) { sync(e.matches); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
